import { render, staticRenderFns } from "./IncorporatedDocumentsTab.vue?vue&type=template&id=44103e44&"
import script from "./IncorporatedDocumentsTab.vue?vue&type=script&lang=ts&"
export * from "./IncorporatedDocumentsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports